<template>
  <b-row v-show="!isRoleDisabled(item)">
    <b-col>
      <div class="form-group">
        <label class="form-control-label">{{ item.label }}:</label>
        <input
          v-if="item.type === 'input'"
          class="form-control"
          type="text"
          v-model="item.value"
          :required="item.required"
          :name="item.name"
          placeholder="">
        <fg-input v-else-if="item.type === 'select'">
          <el-select
            class="select-default"
            placeholder=""
            filterable
            v-model="item.value">
            <el-option v-for="option in item.options"
                       class="select-default"
                       :value="option['value']"
                       :label="option['value']"
                       :key="option['value']">
            </el-option>
          </el-select>
        </fg-input>
        <fg-input v-else-if="item.type === 'datetime'">
          <el-date-picker
            :picker-options="{firstDayOfWeek: 1}"
            v-model="item.value"
            type="date"
            default-time="12:00:00">
          </el-date-picker>
        </fg-input>
        <div v-else-if="item.type === 'multiSelect'" v-for="(option, index) in item.options" :key="index">
          <b-form-checkbox v-model="item.value" :id="'checkbox_'+index+item.name" :value="option.value"
          >{{option.value}}</b-form-checkbox>
        </div>
        <quill-editor v-else-if="item.type === 'inputFormatted'" v-model="item.value"></quill-editor>
        <items-collection-custom-field v-else-if="item.type === 'itemsCollection'" :data="item"></items-collection-custom-field>
        <id-user-data-custom-field v-else-if="item.type === 'idUserData'" :data="item"></id-user-data-custom-field>
      </div>
    </b-col>
  </b-row>
</template>

<script>
import { getUserRoles } from '@/utils/checkRoles'
import QuillEditor from '@/components/UIComponents/Inputs/quillEditor.vue'
import ItemsCollectionCustomField from '@/components/Dashboard/Views/excmcase/components/itemsCollectionCustomField.vue'
import IdUserDataCustomField from '@/components/Dashboard/Views/excmcase/components/idUserDataCustomField.vue'

export default {
  name: 'CasesCustomFields',
  components: { IdUserDataCustomField, ItemsCollectionCustomField, QuillEditor },
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
    }
  },
  created () {
  },
  methods: {
    isRoleDisabled (customField) {
      if (customField.disabledRoles && customField.disabledRoles.length > 0) {
        let idClientType = getUserRoles().id_client_type
        if (customField.disabledRoles.includes(idClientType)) {
          return true
        }
      }
      return false
    }
  }
}
</script>
